<template>
  <div class="DataTable_box">
    <!-- <ModuleName :ModouleName="ModouleName"></ModuleName> -->
    <div class="DataTable">
      <div class="table_header">
        <span
          v-for="(item, index) in list"
          :class="[active == index ? 'active' : '']"
          :key="index"
          @click="change(index)"
        >
          {{ item.name }}
        </span>
      </div>

      <div class="flex">
        <div class="tab1" v-if="active == 0">
          <div class="btn_box">
            <Button
              v-for="(item, index) in btnData"
              :key="index"
              :Data="item"
              @click.native="tableBtnFun(item.type)"
            ></Button>

            <!-- <div v-else style="fontSize:14px;margin:0 10px;color:#999;">
               
              {{$t('DataDetails.Description')}}
            </div> -->
          </div>
          <!-- {{dataListTable.tableData}} -->
          <div class="tableBox" v-if="dataListTable">
            <div class="table_box">
              <el-table
                :data="dataListTable.tableData.list"
                @selection-change="handleSelectionChange"
              >
                <el-table-column type="selection" width="35"></el-table-column>
                <el-table-column
                  :show-overflow-tooltip="
                    item.enNames != 'thumbnail' ? true : false
                  "
                  v-for="(item, index) in dataListTable.hearder"
                  :key="index"
                  :prop="item.enNames"
                  :label="language == 'zh' ? item.cnNames : item.displayNames"
                >
                  <!-- <template slot-scope="scope"> -->
                  <div slot-scope="scope">
                    <img
                      v-if="item.enNames == 'thumbnail'"
                      :src="`data:image/jpeg;base64,${scope.row.thumbnail}`"
                      alt=""
                      width="40px"
                      height="40px"
                    />
                    <div v-else-if="item.enNames == 'fileExist'">
                      <div>
                        {{
                          scope.row[item.enNames] == 1
                            ? $t("DataDetails.Present")
                            : $t("DataDetails.NotPresent")
                        }}
                      </div>
                    </div>
                    <div v-else class="cell el-tooltip" style="padding: 0">
                      {{ scope.row[item.enNames] }}
                    </div>
                  </div>

                  <!-- </template> -->
                </el-table-column>

                <el-table-column
                  width="100px"
                  :label="$t('DataInfo.Operation')"
                >
                  <template slot-scope="scope">
                    <div class="operaBtn">
                      <div
                        class="btn"
                        @click="addShoppingCart(scope.row)"
                        type="text"
                        v-log="{ params: { clickName: '添加购物车' } }"
                      >
                        <i class="iconfont icon-gouwuche"></i>
                      </div>
                      <!--  @click="addShoppingCart(scope.row)" -->
                      <!-- {{DataTable.sharingMethod}} -->
                      <el-popconfirm
                        v-if="
                          scope.row.fileExist == 1 &&
                          DataTable.sharingMethod == 0
                        "
                        @onConfirm="batchBtn(scope.row)"
                        :title="$t('DataDetails.tip.downloadData')"
                        :confirm-button-text="$t('DataDetails.tip.confirm')"
                        :cancel-button-text="$t('DataDetails.tip.cancel')"
                      >
                        <i slot="reference" class="iconfont icon-xiazai5"></i>
                      </el-popconfirm>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="footer_pages">
              <el-pagination
                class="pagination_box"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage"
                :page-size="pageSize"
                layout="prev, pager, next, jumper"
                :total="total"
              >
              </el-pagination>
            </div>
          </div>
        </div>
        <!-- <div class="tab2" v-if="active == 1">
       
          <div v-for="(item, index) in 4" :key="index">
            {{ index + 1 }}. 2022-08-03 12*
            {{ $t("DataDetails.Use") }}：一带一路 ……
          </div>
       
        </div> -->
        <div class="tab3" v-if="active == 1">
          <img class="noData" src="@/assets/image/DataHub/noData.png" alt="" />
          <p>{{ $t("DataDetails.noData") }}</p>
        </div>
      </div>
      <LoginDialog></LoginDialog>
    </div>
  </div>
</template>

<script>
import bus from "@/bus";
import { mapMixin } from "@/util/mixin";
import { dataList, datainfo, otherData } from "@/axios/datashare.js";
import { downloadExist, shoppingCart } from "@/axios/datashare.js";
import { addbatchShoppingCart } from "@/axios/private.js";
export default {
  mixins: [mapMixin],
  props: ["DataTable"],
  mounted() {
    this.getDataList();
  },
  computed: {
    ModouleName() {
      return this.$t("DataDetails.relatedResources");
    },
    btnData() {
      return [
        {
          type: "batchShoppingCart",
          name: this.$t("DataDetails.addCart"),
          iconfont: "iconfont icon-piliang",
          border: "1px solid rgba(18, 139, 237, 1)",
          background: "rgba(18, 139, 237, 1)",
          color: "#fff",
        },
      ];
    },
    list() {
      return [
        {
          name: this.$t("DataDetails.localFiles"),
        },
        
        {
          name: this.$t("DataDetails.relatedDocuments"),
        },
      ];
    },
  },
  data() {
    return {
      // ModouleName: "相关资源",
      dialogVisible: false,
      currentPage4: 4,
      active: 0,
      dataId: null,
      currentPage: 1,
      pageSizes: 10,
      total: null,
      tableData: null,
      collectionData: [],
    };
  },
  components: {
    Button: () => import("@/components/DataDetails/Details/Button.vue"),
    ModuleName: () => import("@/components/DataDetails/Details/ModuleName.vue"),
    LoginDialog: () =>
      import("@/components/PublicComponents/LoginDialog/LoginDialog.vue"),
  },
  methods: {
    batchBtn(obj) {
      var userVerifyLogin = this.verifyLogin();
      if (!userVerifyLogin) {
        // 提示用户登录
        // this.dialogVisible = true;
        bus.$emit("LoginDialogEmit");
        return;
      }
      console.log(obj, this.DataTable);
      var token = localStorage.getItem("token");
      if (!token) {
        bus.$emit("LoginDialogEmit");
        return
      }

      // return
      const a = document.createElement("a"); // 创建a标签
      a.setAttribute("download", ""); // download属性
      a.setAttribute(
        "href",
        // ${this.GLOBAL.url}
        `${this.GLOBAL.url}/sdg-api/share/data/download?dataId=${
          obj.data_id
        }&productCode=${this.dataId}&lang=${
          this.language == "zh" ? "zh_CN" : "en_US"
        }&token=${token}`
      ); // href链接
      // productCode=${scope.row.product_code}
      a.click(); // 自执行点击事件
    },
    async addbatchShoppingCartFun(param) {
      return await addbatchShoppingCart(param);
    },
    // 校验是否登录
    verifyLogin() {
      return localStorage.getItem("token") && localStorage.getItem("loginName") ;
    },
    // 下载函数
    async downloadExistFun(param) {
      return await downloadExist(param);
    },
    // 添加到购物车
    addShoppingCart(obj) {
      var userVerifyLogin = this.verifyLogin();
      if (!userVerifyLogin) {
        // 提示用户登录
        // this.dialogVisible = true;
        bus.$emit("LoginDialogEmit");
        return;
      }
      var idsStr;
      if (obj) {
        // 单个收藏
        idsStr = obj.data_id;
      } else {
        if (this.collectionData.length == 0) {
          this.$message({
            message: this.$t("DataDetails.tip.dataEntry"),
            duration: 1000,
          });
          return;
        }
        // 批量收藏
        var idsArr = [];
        this.collectionData.forEach((item) => {
          idsArr.push(item.data_id);
        });
        idsStr = idsArr.join(",");
      }
      var param = {
        dataIds: idsStr,
        productName: this.DataTable.productName,
        productCode: this.DataTable.dataId,
      };

      this.addbatchShoppingCartFun(param).then((res) => {
        console.log(res.data.code);
        if (res.data.code == 200) {
          this.$message.closeAll();
          this.$message({
            message: this.$t("DataDetails.tip.successfully"),
            duration: 1000,
            type: "success",
          });
        }
      });
    },

    // 获取表格数据
    async getDataList() {
      this.dataId = this.$route.query.dataId;
      var param = {
        id: this.dataId,
        currentPage: this.currentPage,
        pageSizes: this.pageSizes,
      };
      try {
        var res = await dataList(param);
      } catch (error) {
        this.setDataListTable();
      }
      var data = res.data.data;
      if (!data) {
        this.setDataListTable();
        // return;
      }
      var cnNames = data.cnNames.split(",");
      var enNames = data.enNames.split(",");
      var displayNames = data.displayNames.split(",");
      var name = [];

      for (var i = 0; i < cnNames.length; i++) {
        name.push({
          cnNames: cnNames[i],
          enNames: enNames[i],
          displayNames: displayNames[i],
        });
      }
      this.tableData = data.pageVo;
      this.total = data.pageVo.total;
      var obj = {
        tableData: this.tableData,
        hearder: name,
        total: "",
        currentPage: "",
      };
      this.setDataListTable(obj);
    },
    //根据type 判断是批量收藏下载
    tableBtnFun(type) {
      if (type == "batchShoppingCart") {
        this.addShoppingCart();
      } else if (type == "Download") {
        this.Download();
      }
    },
    // 批量收藏
    async CollectionFun() {
      var userVerifyLogin = this.verifyLogin();
      if (!userVerifyLogin) {
        // 提示用户登录
        this.dialogVisible = true;
        return;
      }
      if (!this.collectionData || this.collectionData.length == 0) {
        this.$message({
          message: this.$t("DataDetails.tip.dataEntry"),
          duration: 1000,
        });
        return;
      }

      var dataIdArr = [];
      this.collectionData.forEach((item) => {
        dataIdArr.push(item.data_id);
      });
      var param = {
        productCode: this.dataId,
        productName: this.DataTable.productName,
        createBy: this.loginName,
        dataIds: dataIdArr.join(","),
      };
      var res = await shoppingCart(param);
      console.log(res);
      if (res.data.code == 200) {
        this.$message({
          message: this.$t("DataDetails.tip.successfully"),
          duration: 1000,
          type: "success",
        });
      } else {
        this.$message.error({
          message: this.$t("DataDetails.tip.failure"),
          duration: 1000,
        });
      }
    },
    // 批量下载
    Download() {
      var userVerifyLogin = this.verifyLogin();
      if (!userVerifyLogin) {
        // 提示用户登录
        this.dialogVisible = true;
        return;
      }
      console.log(this.collectionData);
      if (!this.collectionData || this.collectionData.length == 0) {
        this.$message("请选择数据条目");
        return;
      }

      var dataIdArr = [];
      this.collectionData.forEach((item) => {
        dataIdArr.push(item.data_id);
      });
      const a = document.createElement("a"); // 创建a标签
      a.setAttribute("download", ""); // download属性
      a.setAttribute(
        "href",
        `${this.GLOBAL.url}sdg-api/share/data/batch/download?productCode=${
          this.dataId
        }&productName=${this.DataTable.productName}&dataIds=${dataIdArr.join(
          ","
        )}`
      ); // href链接
      // productCode=${scope.row.product_code}
      a.click(); // 自执行点击事件
    },

    handleClose() {
      this.dialogVisible = false;
    },
    handleSelectionChange(obj) {
      console.log(obj);
      this.collectionData = obj;
    },
    change(index) {
      this.active = index;
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.getDataList();
      console.log(`当前页: ${val}`);
    },
  },
};
</script>

<style lang="scss" >
.DataTable {
  width: 825px;
  margin-top: 24px;
  border: 1px solid #eeeeee;
  .el-table td {
    padding: 12px 0;
  }
}
.table_header {
  display: flex;
  flex-direction: row;
  background: rgba(247, 249, 252, 1);
  span {
    height: 42px;
    line-height: 42px;
    font-size: 14px;
    padding: 0 40px;
    cursor: pointer;
    transition: 0.2s;
    &:hover {
      background: rgb(253, 253, 253);
      transition: 0.2s;
    }
  }
  .active {
    background: #fff;
  }
}
.flex {
  // display: flex;
  // width: 865px;

  //   width: 500px;
  .tab3 {
    padding: 10px 20px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .tab2 {
    padding: 10px 20px;
    font-size: 14px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    div {
      margin-top: 10px;
      text-align: left;
      line-height: 24px;
    }
  }
  .btn_box {
    margin: 10px;
    display: flex;
    justify-content: flex-start;
    border-bottom: 1px solid #fbfbfb;
  }

  .noData {
    margin-top: 60px;
    width: 200px;
    height: 193px;
  }
  p {
    text-align: center;
    font-size: 14px;
    color: #333333;
    margin-bottom: 140px;
  }
}
.tableBox {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  //   justify-content: space-between;
  .footer_pages {
    width: 825px;
    .pagination_box {
      margin: 30px auto;
      width: 825px;
      text-align: center;
    }
  }
  .table_box {
    width: 100%;
    // flex: 1;
  }
  .operaBtn {
    display: flex;
    i {
      cursor: pointer;
      margin-right: 10px;
    }
  }
}
</style>